<p class="logout-message">Logging out...</p>
